import BaseManager from "./BaseManager";
import Facade from "@/Facade";
import '../externals/ppb-game-client-api-1.0.8'


export const LIGHT_AND_WONDER_RECEIVE_MESSAGE_TYPE  = {
    BALANCE_HAS_CHANGED: 'com.lnw.gcm.balancesHasChanged',
    OPTION_HAS_CHANGED: 'com.lnw.gcm.optionHasChanged',
    STOP_AUTOPLAY: 'com.lnw.gcm.stopAutoPlay',
    RESUME: 'com.lnw.gcm.resume',
}

export const LIGHT_AND_WONDER_EVENT  = {
    INIT : 'com.lnw.gcm.initialiseChannel',
    SET_GAME_CONFIG : 'com.lnw.gcm.setGameConfig',
    PROGRESS_UPDATE : 'com.lnw.gcm.loadProgressUpdate',
    GAME_READY : 'com.lnw.gcm.gameReady',
    REGISTER_OPTION : 'com.lnw.gcm.regOption',
    BALANCE_UPDATE : 'com.lnw.gcm.balancesUpdate',
    PAID_UPDATE : 'com.lnw.gcm.paidUpdate',
    STAKE_UPDATE : 'com.lnw.gcm.stakeUpdate',
    OPTION_HAS_CHANGED : 'com.lnw.gcm.optionHasChanged',
    ROUND_START : 'com.lnw.gcm.gameAnimationStart',
    ROUND_END : 'com.lnw.gcm.gameAnimationComplete',
    HANDLE_ERROR : 'com.lnw.gcm.handleError',
    HANDLE_MESSAGE_TRIGGER: 'com.lnw.gcm.handleMessageTrigger'
}

export const LIGHT_AND_WONDER_ERROR_CATEGORY = {
    NON_RECOVERABLE_ERROR : 'NON_RECOVERABLE_ERROR',
    CRITICAL : 'CRITICAL',
    INSUFFICIENT_FUNDS : 'INSUFFICIENT_FUNDS',
}

export const LIGHT_AND_WONDER_ERROR_SEVERITY =  {
    WARNING : 'WARNING',
    INFO : 'INFO',
    ERROR : 'ERROR',
}

export default class LightAndWonderManager extends BaseManager {
    messagingChannel
    messagePorts = {
        port1: null,
        port2: null
    }
    BALANCE_MULTIPLIER = 100;

    constructor() {
        super()
    }

    init(adapter) {
        super.init(adapter)
    }

    relaxConfigure(data) {
        this.messagingChannel = new MessageChannel()
        this.messagePorts = {
            port1: this.messagingChannel.port1,
            port2: this.messagingChannel.port2,
        }

        window.parent.postMessage(this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.INIT), '*', [this.messagePorts.port2])
        this.messagePorts.port1.onmessage = this._onGcmMsgReceived.bind(this)

        //SEND GCM GAME CONFIG SETTINGS
        this.messagePorts.port1.postMessage(
            this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.SET_GAME_CONFIG, {
                cuiPosition: 'centre', // LEFT | RIGHT | CENTRE (TODO TO VERIFY LOCATION WE NEED TO USE)
                gameLoadingScreen: true,
                gameName: 'Gaming Corps',
            })
        )

        //REGISTER OPTIONS
        const availableOptions = [ 'MUTE', 'ABOUT', 'HELP', 'PAYTABLE']
        availableOptions.forEach((option) => {
            this.messagePorts.port1.postMessage(
                this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.REGISTER_OPTION, {
                    optionType: option, // MUTE | ABOUT | HELP | PAYTABLE
                })
            )
        })
    }

    _prepareGcmMsg(event, data) {
        const msg = JSON.stringify({
            eventName: event,
            eventData: data ?? {},
        })

        console.warn("::: L&W Sent", msg);
        return msg
    }

    _onGcmMsgReceived(msg) {
        msg = JSON.parse(msg.data)

        console.warn("::: L&W Receive", msg);
        switch (msg.eventName) {
            case LIGHT_AND_WONDER_RECEIVE_MESSAGE_TYPE.BALANCE_HAS_CHANGED:
                this.adapter.updateBalance()
                break
            case LIGHT_AND_WONDER_RECEIVE_MESSAGE_TYPE.STOP_AUTOPLAY:
                this.adapter.stopAutospins()
                break
            case LIGHT_AND_WONDER_RECEIVE_MESSAGE_TYPE.RESUME:
                this.adapter.unfreeze()
                break
            case LIGHT_AND_WONDER_RECEIVE_MESSAGE_TYPE.OPTION_HAS_CHANGED:
                switch (msg.eventData.option) {
                    case 'MUTE':
                        this.adapter.setAudio(!msg.eventData.value)
                        break
                    case 'ABOUT':
                        this.adapter.showHelp()
                        break
                    case 'HELP':
                        this.adapter.showHelp()
                        break
                    case 'PAYTABLE':
                        this.adapter.togglePaytable()
                        break
                }
                break
        }
    }

    loadProgress(progress) {
        this.messagePorts.port1.postMessage(
            this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.PROGRESS_UPDATE, {
                percent: progress,
            })
        )
    }

    loadCompleted() {
        this.balanceUpdate(Facade.model.balance, Facade.model.bonusBalance)
        this.messagePorts.port1.postMessage(
            this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.PAID_UPDATE, {
                amount: 0,
            })
        )
        this.messagePorts.port1.postMessage(this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.GAME_READY))

        if(Facade.urlParams.customer === "lightandwonder_test" || Facade.urlParams.customer === 'lightandwonder'){
            this.adapter.disableGamePopups();
        }

        if (Facade.model._initRawData?.tpd) {
            const msg = JSON.parse(Facade.model._initRawData?.tpd)
            this._handleErrorMessageTrigger(msg.light_and_wonder)
        }
    }


    audioToggle(state) {
        this.messagePorts.port1.postMessage(
            this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.OPTION_HAS_CHANGED, {
                optionType: 'MUTE',
                newValue: !state,
                changedFrom: 'GAME',
            })
        )
    }

    roundStart(value = 0) {
        this.messagePorts.port1.postMessage(this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.ROUND_START));
        this.winUpdate(0);
        this.balanceUpdate(value,Facade.model.balance);
    }

    roundEnd({balance = 0, totalBet = 0, totalWin = 0}) {
        this.winUpdate(totalWin);
        this.balanceUpdate(balance,Facade.model.balance);
        this.messagePorts.port1.postMessage(this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.ROUND_END))
    }

    winUpdate(updatedWin) {
        this.messagePorts.port1.postMessage(
            this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.PAID_UPDATE, {
                amount: this.toWhole(updatedWin),
            })
        )
    }

    //DUPLICATE OF BET UPDATE
    stakeUpdate(data) {
        this.messagePorts.port1.postMessage(
            this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.STAKE_UPDATE, {
                amount: this.toWhole(data),
            })
        )
    }

    betUpdate(data) {
        this.messagePorts.port1.postMessage(
            this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.STAKE_UPDATE, {
                amount: this.toWhole(data),
            })
        )
    }


    closed() {
        // this.gc.sendEvent('exitGame')
    }

    _handleErrorMessageTrigger(xml) {
        if (xml == null) {
            return
        }
        this.messagePorts.port1.postMessage(
            this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.HANDLE_MESSAGE_TRIGGER, {
                msgTriggerData: xml,
            })
        )
    }

    errorMessage(data) {
        try {
            const msg = JSON.parse(data.message)

            msg.rawErrorMessage === true
                ? this._handleErrorMessageTrigger(msg.third_party_message)
                : this.messagePorts.port1.postMessage(
                    this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.HANDLE_ERROR, {
                        category: msg.category,
                        severity: msg.severity,
                        errorCode: msg.third_party_error_code,
                        message: msg.message,
                    })
                )
        } catch (error) {
            console.warn('::: L&W ERROR Not formatted correctly ', error)
        }
    }

    balanceUpdate(value, bonusBalance = 0) {
        this.messagePorts.port1.postMessage(
            this._prepareGcmMsg(LIGHT_AND_WONDER_EVENT.BALANCE_UPDATE, {
                balances: {
                    CASH: this.toWhole(value - bonusBalance),
                    BONUS: this.toWhole(bonusBalance)
                },
            })
        )
    }

    toWhole(value) {
        return parseFloat((value / this.BALANCE_MULTIPLIER).toFixed(2))
    }
}
